import React, { useState, useEffect } from 'react'
import { IconButton, TextField, Divider, debounce } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import AddCircleIcon from '@mui/icons-material/AddCircle'
import { GridColDef, GridPaginationModel, GridRowParams, GridValueGetterParams, ptBR } from '@mui/x-data-grid'
import { Header, Content, Image, StyledDataGrid } from './style'
import VendedoresIcon from '../../../assets/vendedores.png'
import Vendedor from '../../../interfaces/vendedor'
import VendedorDialog from '../../components/VendedorDialog'
import pagedGet from '../../../services/pagedGet'
import { DEFAULT_PAGE_SIZE } from '../../../interfaces/pagedResult'

const Vendedores: React.FC = () => {
  const [pesquisa, setPesquisa] = useState<string>('')
  const [dialogAberto, setDialogAberto] = useState<boolean>(false)
  const [vendedorSelecionado, setVendedorSelecionado] = useState<Vendedor | null>(null)
  const [vendedores, setVendedores] = useState<Vendedor[]>([])
  const [pesquisarTrigger, setPesquisarTrigger] = useState<boolean>(false);
  const [paginationModel, setPaginationModel] = useState<GridPaginationModel>({
    page: 0,
    pageSize: DEFAULT_PAGE_SIZE,
  })
  const [rowCount, setRowCount] = useState(0)

  const pesquisar = debounce((event: React.ChangeEvent<HTMLInputElement>) => {
    setPesquisa(event.target.value);
    setPaginationModel(prev => ({ ...prev, page: 0 }))
  }, 500)

  useEffect(() => {
    if (dialogAberto)
      return

    const buscarDados = async () => {
      const result = await pagedGet<Vendedor>('/vendedor', {
        page: paginationModel.page + 1,
        pageSize: paginationModel.pageSize,
        pesquisa: pesquisa || undefined,
      })
      setVendedores(result.items)
      setRowCount(result.totalCount)
    }

    buscarDados()
  }, [pesquisa, pesquisarTrigger, dialogAberto, paginationModel])

  const colunas: GridColDef[] = [
    {
      field: 'usuarioLogin',
      headerName: 'Usuario',
      width: 300,
      valueGetter: (getter: GridValueGetterParams) => {
        return getter.value === null ? '-' : getter.value
      }
    },
    {
      field: 'nome',
      headerName: 'Nome',
      flex: 1
    },
    {
      field: 'percentualComissao',
      headerName: 'Comissão (%)',
      flex: 1,
      valueGetter: (getter: GridValueGetterParams) => {
        return getter.value === null ? '-' : getter.value.toFixed(2)
      }
    }
  ]

  const handleAdicionar = () => {
    setVendedorSelecionado(null)
    setDialogAberto(!dialogAberto)
  }

  const handleClickLinha = (params: GridRowParams) => {
    setVendedorSelecionado(params.row as Vendedor)
    setDialogAberto(true)
  }

  return (
    <>
      <Image src={VendedoresIcon} />
      <Header>
        <TextField
          id="pesquisa"
          label="Pesquisar"
          onChange={pesquisar}
          type="search"
          fullWidth
          autoFocus
          autoComplete='off'
          inputProps={{ style: { textTransform: "uppercase" } }}
        />
        <IconButton
          color="primary"
          onClick={_ => setPesquisarTrigger(!pesquisarTrigger)}
        >
          <SearchIcon />
        </IconButton>
        <Divider orientation="vertical" variant="middle" flexItem />
        <IconButton
          onClick={handleAdicionar}
          color="primary"
        >
          <AddCircleIcon />
        </IconButton>
      </Header>
      <Content>
        <StyledDataGrid
          localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
          columns={colunas}
          rows={vendedores}
          disableColumnMenu={true}
          hideFooterSelectedRowCount={true}
          onRowClick={handleClickLinha}
          pagination
          paginationMode="server"
          paginationModel={paginationModel}
          onPaginationModelChange={setPaginationModel}
          rowCount={rowCount}
          pageSizeOptions={[20, 50, 100]}
          sx={{
            textTransform: 'uppercase'
          }}
        />
      </Content>
      {dialogAberto ? <VendedorDialog aberto={dialogAberto} setAberto={setDialogAberto} entidade={vendedorSelecionado} /> : <></>}
    </>
  )
}

export default Vendedores
